import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'view-statutes',
  templateUrl: './view-statutes.component.html',
  styleUrl: './view-statutes.component.css'
})
export class ViewStatutesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  downloadPdf(name:string){
    const pdfUrl = `assets/statutes/${name}.pdf`; // Ścieżka do pliku PDF w katalogu assets
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = `${name}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
